import React from "react";
import { Link } from "@sainsburys-tech/luna-link";

import { missionId, getNectarRegisterUrl } from "utils/urls";
import { missionNames } from "constants/missions";

import RouterLink from "components/RouterLink";

const config = {};

const missionContent = {
  [missionNames.GOL]: {
    registerNotification: {
      registerLabel: "New to Sainsbury’s Groceries?",
      registerLink: (
        <RouterLink
          data-testid="register"
          link="/gol/email-verification"
          className="ln-c-button ln-c-button--outlined ln-c-button--full"
          style={{ maxWidth: "20rem" }}
        >
          Register here
        </RouterLink>
      ),
    },
    progressiveRegistration: {
      title: "Looks like you have an account",
      copy: [
        "Sainsbury’s Groceries, Nectar and SmartShop accounts now use My ID, a service that allows customers to use the same login information for both accounts.",
        "This means you can easily register for Sainsbury’s Groceries by using your Nectar or SmartShop email and password.",
        "By using your existing details in the next page, we'll automatically link the two accounts for you once you complete your registration.",
      ],
    },
    resetPasswordNotification:
      "Updating your Sainsbury's Groceries password will also update your password for Nectar or SmartShop accounts which are associated with the same email.",
  },
  [missionNames.NECTAR]: {
    registerNotification: {
      registerLabel: "Not got a digital account?",
      registerLink: (
        <Link
          data-testid="register"
          href={getNectarRegisterUrl()}
          className="ln-c-button ln-c-button--outlined ln-c-button--full ln-c-link ln-c-link--bare ln-c-link--alpha"
          style={{ maxWidth: "20rem" }}
        >
          Register for Nectar
        </Link>
      ),
    },
    progressiveRegistration: {
      title: "Looks like you have an account",
      copy: [
        "Nectar, Sainsbury’s Groceries and SmartShop accounts now use My ID, a service that allows customers to use the same login information for both accounts. This means you can easily register for Nectar by using your Sainsbury’s Groceries or SmartShop email and password.",
        "By using your Sainsbury's Groceries or SmartShop details in the next page, we'll automatically link the two accounts for you once you complete your registration.",
      ],
      helpText: "",
    },
    resetPasswordNotification:
      "Updating your Nectar password will also update your password for Sainsbury’s Groceries or SmartShop accounts which are associated with the same email.",
  },
};

missionContent[missionNames.MYACCOUNT] = {
  ...missionContent[missionNames.GOL],
};

missionContent[missionNames.SMARTSHOP] = {
  ...missionContent[missionNames.GOL],
  resetPasswordNotification: "",
};

missionContent[missionNames.SAVINGCARD] = {
  ...missionContent[missionNames.GOL],
  registerNotification: {
    registerLabel: "New to Sainsbury's Savings Card?",
    registerLink: (
      <RouterLink
        data-testid="register"
        link={`/${missionId}/email-verification`}
        className="ln-c-button ln-c-button--outlined ln-c-button--full"
        style={{ maxWidth: "20rem" }}
      >
        Register here
      </RouterLink>
    ),
  },
};

export default missionContent[missionId] || config;
